<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="徽章系列" prop="seriesId">
                <a-select style="width: 100%" v-model="queryParam.seriesId" placeholder="请选择徽章系列" allow-clear>
                  <a-select-option v-for="(item, index) in this.seriesList" :value="item.id" :key="index">
                    {{ item.seriesName }}
                    <span style="color: #497afd" v-if="item.badgeType===1">成长徽章</span>
                    <span style="color: #d93838" v-if="item.badgeType===2">剧本徽章</span>
                    <span style="color: #ff7e05" v-if="item.badgeType===3">活动徽章</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="徽章名称" prop="badgeName">
                <a-input v-model="queryParam.badgeName" placeholder="请输入徽章名称" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['badge:badge:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['badge:badge:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['badge:badge:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['badge:badge:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :rowKey="(record, index) => index + 1"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <div slot="badgeImage" slot-scope="text, record" style="cursor: pointer;">
          <img v-if="record.badgeImage" :src="record.badgeImage" style="width:50px;" preview alt=""/>
        </div>
        <div slot="badgeLabelImage" slot-scope="text, record" style="cursor: pointer;">
          <img v-if="record.badgeLabelImage" :src="record.badgeLabelImage" style="width:200px;" preview alt=""/>
        </div>
        <span slot="status" slot-scope="text, record">
          {{ record.status === 1 ? '启用' : '禁用' }}
        </span>
        <span slot="badgeLevel" slot-scope="text, record">
          {{ 'Level.' + record.badgeLevel }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.userGrantList.open(record.id)" v-if="record.badgeType === 3" v-hasPermi="['badge:badge:edit']">
            <a-icon type="user" />发放用户
          </a>
          <a-divider type="vertical" v-if="record.badgeType === 3" v-hasPermi="['badge:badge:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['badge:badge:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['badge:badge:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['badge:badge:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :pageSizeOptions="['10', '20', '50', '100']"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <user-grant-list ref="userGrantList" @grantUser="grantUser"></user-grant-list>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listBadge, delBadge } from '@/api/badge/badge'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import UserGrantList from '@/components/User/UserGrantList.vue'
import { addBadgeUser } from '@/api/badge/badgeUser'
import { listBadgeSeries } from '@/api/badge/badgeSeries'

export default {
  name: 'Badge',
  components: {
    UserGrantList,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        seriesId: undefined,
        badgeName: null,
        badgeLevel: null,
        badgeImage: null,
        badgeLabelImage: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          ellipsis: true,
          align: 'center',
          customRender: (text, record, index) => index + 1
        },
        // {
        //   title: 'id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '徽章系列名',
          dataIndex: 'seriesName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '徽章名称',
          dataIndex: 'badgeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '徽章等级',
          dataIndex: 'badgeLevel',
          scopedSlots: { customRender: 'badgeLevel' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '徽章图片',
          dataIndex: 'badgeImage',
          scopedSlots: { customRender: 'badgeImage' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '徽章标签图片',
          dataIndex: 'badgeLabelImage',
          scopedSlots: { customRender: 'badgeLabelImage' },
          ellipsis: true,
          width: 240,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      seriesList: []
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getSeriesList()
  },
  methods: {
    /** 查询徽章系列列表 */
    getSeriesList() {
      listBadgeSeries({ pageNum: 1, pageSize: 50 }).then(res => {
        this.seriesList = res.data.records
      })
    },
    /** 查询徽章列表 */
    getList () {
      this.loading = true
      listBadge(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        seriesId: undefined,
        badgeName: undefined,
        badgeLevel: undefined,
        badgeImage: undefined,
        badgeLabelImage: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delBadge(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('badge/badge/export', {
            ...that.queryParam
          }, `badge_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    grantUser (row, relationId) {
      const that = this
      this.$confirm({
        title: '确认给`' + row.nickName + '`发放徽章?',
        onOk() {
          const data = {
            userId: row.id,
            badgeId: relationId,
            allocationForm: 2
          }
          return addBadgeUser(data).then(() => {
              that.$refs.userGrantList.onSelectChange([], [])
              that.$refs.userGrantList.getList(3)
              that.$message.success(
                '发放成功',
                3
              )
            })
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
